// extracted by mini-css-extract-plugin
module.exports = {"container":"admin-fee_container__BhpnC","button":"admin-fee_button__1niHf","drawerContainer":"admin-fee_drawerContainer__jvLd7","drawerText":"admin-fee_drawerText__3fwx5"};